/**
 * HARDLOCK v18.12.71-STABLE-HYDRATION-FIX
 * Archivo critico de Planeacion/Seguimiento.
 * No modificar sin snapshot, pruebas hardlock, localhost validation y revision de no regresion.
 */
import { SectionNumber, SectionContract, SupportedSectionType } from './planningTypes';

import { deepFreeze } from './planningGuards';

export const SUPPORTED_SECTION_TYPES: SupportedSectionType[] = deepFreeze([
    'OBJECTIVES', 'DIAGNOSTIC', 'STRUCTURE', 'COMMISSIONS', 'EVENTS', 'PROJECTS', 'AGREEMENTS', 'TOPICS'
]);

export const PLANNING_SECTION_CONTRACT: Record<SectionNumber, SectionContract> = deepFreeze({
    1: { type: 'OBJECTIVES', component: 'GenericTableEditor', canonicalKey: 'sec1_data', configKey: '_config_columns_sec1' },
    2: { type: 'OBJECTIVES', component: 'GenericTableEditor', canonicalKey: 'sec2_data', configKey: '_config_columns_sec2' },
    3: { type: 'DIAGNOSTIC', component: 'DiagnosticoFormat', canonicalKey: 'sec3_data', configKey: '_config_columns_sec3' },
    4: { type: 'STRUCTURE', component: 'GenericTableEditor', canonicalKey: 'sec4_data', configKey: '_config_columns_sec4' },
    5: { type: 'COMMISSIONS', component: 'ComisionesManager', canonicalKey: 'sec5_data', configKey: '_config_columns_sec5' },
    6: { type: 'EVENTS', component: 'GenericTableEditor', canonicalKey: 'sec6_data', configKey: '_config_columns_sec6' },
    7: { type: 'PROJECTS', component: 'ProyectosCardsEditor', canonicalKey: 'sec7_data', configKey: '_config_columns_sec7' },
    8: { type: 'AGREEMENTS', component: 'GenericTableEditor', canonicalKey: 'convenios_data', configKey: '_config_columns_sec8' },
    9: { type: 'TOPICS', component: 'GenericTableEditor', canonicalKey: 'sec9_data', configKey: '_config_columns_sec9' },
});

export const DYNAMIC_SECTIONS: SectionNumber[] = deepFreeze([5]); 

export const ENGINE_VERSION = "v18.12.71-HYDRATION-PERSISTENCE-HARDLOCK";
export const RUNTIME_INTEGRITY_SHIELD = true;
export const STRICT_CONTRACT_VALIDATION = true;

export const IGNORED_KEYS = deepFreeze([
    'id', 'key', 'index', 'type', 'order', 'color', 'created_at', 'updated_at', '_id', 'rowId',
    'centro', 'centro_empresarial', 'entidad', 'federacion', 'nombre_centro',
    'meta_vinculacion', 'estatus', 'meta', 'status', 'estado'
]);

export const SAFE_RUNTIME_KEYS = deepFreeze(['_id', 'rowId', 'tempId', 'lastUpdated', 'isNew', '__v', '_rev']);

export const INVALID_PLACEHOLDERS = deepFreeze([
    "ESCRIBIR AQUÍ", "ESCRIBIR AQUI", "ESCRIBIR AQUÍ...", "ESCRIBIR AQUI...",
    "ESCRIBE AQUÍ", "ESCRIBE AQUI", "ESCRIBA AQUÍ", "ESCRIBA AQUI",
    "PÉNDIENTE", "PENDIENTE", "POR DEFINIR", "SIN ASIGNAR", "NO APLICA", "N/A", 
    "---", "--", "-", "W", "EJEMPLO", "PRUEBA", ".", "0", "N/D", "SD", "S/D",
    "NOMBRE DE VICEPRESIDENCIA", "TITULO", "ETIQUETA", "TEXTO AUXILIAR",
    "OBJETIVO ESTRATEGICO", "ACCION PRIORITARIA", "OBJETIVO", "ACCION",
    "SIN NOMBRE", "SIN TITULO", "SIN DESCRIPCION", "NULL", "UNDEFINED", "NAN",
    "VIGENTE", "VIGENTE...", "POR VENCER", "RENOVACIÓN", "CONCLUIDO", "EN PROCESO", "COMPLETADO"
]);

export const SECTION_FIELDS: Record<number, string[]> = deepFreeze({
    1: ['no_oe', 'objetivo_agenda', 'no_ap', 'accion_prioritaria', 'objetivo', 'accion', 'acciones_estrategicas'],
    2: ['no_oe', 'objetivo_estrategico', 'no_ap', 'accion_prioritaria', 'objetivo', 'accion'],
    4: ['vicepresidencia', 'nombre_responsable', 'celular', 'responsable', 'cargo'],
    5: ['instancia', 'comentarios_vinculacion', 'comentarios', 'cumplimiento', 'estatus', 'fecha_vinculacion', 'acuerdos'],
    6: ['mes', 'tema', 'fecha', 'evento', 'lugar'],
    7: [
        'titulo_proyecto', 'nombre', 'descripcion_estrategica', 'objetivo', 
        'avance_implementacion', 'beneficios_socios_directos', 'beneficios_centros_empresariales', 
        'inversion_presupuesto', 'aliados_estrategicos', 'descripcion_avances', 'evidencia',
        'estatus', 'progreso_porcentaje', 'metas', 'aliados'
    ],
    8: [
        'aliado', 'institucion', 'convenio', 'objetivo', 'vencimiento', 'estatus', 'aliado_institucion',
        'resultado', 'beneficio', 'nombre_aliado', 'descripcion_convenio', 'aliado_estrategico'
    ],
    9: ['tema', 't1', 't2', 't3', 't4', 'descripcion', 'objetivo']
});

